import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "../elements/icon";
import Radio from "./radio";
import KeyPressManager from "../../utils/keypress-manager";

var ListboxSelectItem = function ListboxSelectItem(_ref) {
  var item = _ref.item,
      selectedValue = _ref.selectedValue,
      onClick = _ref.onClick,
      closePopover = _ref.closePopover;
  var label = item.label,
      value = item.value,
      icon = item.icon,
      disabled = item.disabled;
  var isSelected = selectedValue ? selectedValue.value === value : undefined;

  var handleClick = function handleClick() {
    if (!disabled) {
      onClick(item);
      closePopover();
    }
  };

  return /*#__PURE__*/React.createElement(KeyPressManager, {
    component: "li",
    onEnter: handleClick,
    onSpace: handleClick,
    className: classNames("et-listbox--item", {
      "et-listbox--item-selected": isSelected,
      "et-listbox--item-disabled": disabled
    }),
    onClick: handleClick,
    role: "option",
    "aria-selected": isSelected
  }, /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--item-radio"
  }, /*#__PURE__*/React.createElement(Radio, {
    checked: isSelected,
    label: label,
    disabled: disabled,
    showLabel: false
  }), /*#__PURE__*/React.createElement("div", null, label)), icon && /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--item-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })));
};

ListboxSelectItem.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  closePopover: PropTypes.func.isRequired,
  selectedValue: PropTypes.any,
  icon: PropTypes.string
};
export default ListboxSelectItem;